import script from "./TmIndexComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TmIndexComponent.vue?vue&type=script&setup=true&lang=js"

import "./TmIndexComponent.vue?vue&type=style&index=0&id=28ee4ffd&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28ee4ffd"]])

export default __exports__